var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-pipeline-step-opp" },
    [
      _vm.showSkeleton
        ? _c("CompassSkeleton", {
            staticClass: "automation-wizard-field-pipeline-step-opp__skeleton",
            attrs: { size: "x-large" }
          })
        : _c(
            "CompassFormItem",
            _vm._b(
              { attrs: { error: _vm.field.currentError || "" } },
              "CompassFormItem",
              _vm.formItemProps,
              false
            ),
            [
              _c(
                "CompassSelect",
                _vm._b(
                  {
                    attrs: {
                      loading: _vm.loading,
                      disabled: _vm.disabled,
                      menuClass: "automation-wizard-pipeline-step-select"
                    },
                    model: {
                      value: _vm.localValue,
                      callback: function($$v) {
                        _vm.localValue = $$v
                      },
                      expression: "localValue"
                    }
                  },
                  "CompassSelect",
                  _vm.selectProps,
                  false
                ),
                _vm._l(_vm.options, function(option) {
                  return _c("CompassDropdownSelectOption", {
                    key: option.value,
                    attrs: { label: option.label, value: option.value }
                  })
                }),
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }